import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const ForgottenPassword = lazy(() => import('components/Sections/ForgottenPass'))
const Footer = lazy(() => import('components/Layout/Footer'))

function ForgottenPass() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <ForgottenPassword />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default ForgottenPass